import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- replace with crystal-ui
import { Dialog, DialogContent, makeStyles, Box } from '@applyboard/ui-components';
import { useIsMobile } from "../../Common/useIsMobile";
import { useOnboardingFormControllerContext } from "../../../controller/OnboardingFormController";
var useStyles = makeStyles({
  dialog: {
    backgroundImage: function backgroundImage(p) {
      return p.isMobile ? 'none' : "url(".concat(p.background, ")");
    },
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'bottom right',
    backgroundSize: 'cover'
  },
  dialogContent: {
    '&.MuiDialogContent-root': {
      padding: 0,
      margin: function margin(p) {
        return p.isMobile && p.stickyButton ? '0 0 56px 0' : 0;
      },
      // Fixes invisible "Next" buttons on mobile iOS
      // -webkit-overflow-scrolling is a non-standard style used only by mobile iOS:
      // https://caniuse.com/mdn-css_properties_-webkit-overflow-scrolling
      // Setting its value to "touch" creates a new stacking context:
      // https://developer.mozilla.org/en-US/docs/Web/CSS/-webkit-overflow-scrolling#syntax
      // Material UI's DialogContent sets the value to "touch":
      // https://github.com/mui-org/material-ui/blob/2d4d0663ff1ed732e6952705d0e23eda13ae25ea/packages/material-ui/src/DialogContent/DialogContent.js#L33
      // The new stacking context breaks the z-ordering of the Next button, displaying it behind
      // the dialog content.  Unsetting the value ensures that the button is visible.
      //
      // The downside is that scrolling won't have "momentum" on some iOS devices.  When time
      // allows, the UI can be restructured so this line isn't needed.
      WebkitOverflowScrolling: function WebkitOverflowScrolling(p) {
        return p.isMobile ? 'unset' : 'auto';
      }
    },
    '&.MuiDialogContent-root:first-child': {
      padding: function padding(p) {
        return p.isMobile ? '0' : 'auto';
      }
    }
  }
});
var MobileDialog = function MobileDialog(_ref) {
  var children = _ref.children,
    _ref$stickyButton = _ref.stickyButton,
    stickyButton = _ref$stickyButton === void 0 ? false : _ref$stickyButton;
  var _useOnboardingFormCon = useOnboardingFormControllerContext(),
    background = _useOnboardingFormCon.background;
  var isMobile = useIsMobile();
  var classes = useStyles({
    isMobile: isMobile,
    stickyButton: stickyButton,
    background: background
  });
  return /*#__PURE__*/React.createElement(Dialog, {
    fullScreen: true,
    open: true,
    scroll: "paper",
    classes: {
      paper: classes.dialog
    }
  }, /*#__PURE__*/React.createElement(DialogContent, {
    className: classes.dialogContent
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "center"
  }, children)));
};
export default MobileDialog;